export default {
  "title": "Academy",
  "subtitle": "Camps, programmes & workshops",
  "explore": "Explore",
  "myBookings": "My bookings",
  "search": "Search programmes",
  "category": "Category",
  "allCategories": "All categories",
  "date": "Date",
  "details": "Programme details",
  "book": "Book",
  "waiting": "Join waiting list",
  "participants": "Participants and dates",
  "summary": "Consent and summary",
  "payment": "Payment",
  "confirm": "Confirm booking",
  "continue": "Continue",
  "back": "Back",
  "consent": "I accept these terms for each selected participant and confirm my authority to book.",
  "total": "Total",
  "net": "Net",
  "tax": "Tax",
  "free": "Free",
  "member_account": "Charge my member account",
  "cash": "Cash received by club",
  "card": "Pay by card",
  "cancel": "Cancel booking",
  "cancelReason": "Cancellation reason",
  "confirmed": "Booking confirmed",
  "held": "Place held — participation is not confirmed",
  "expired": "Hold expired",
  "cancelled": "Cancelled",
  "payment_attention": "Payment needs attention",
  "pending": "Pending",
  "paid": "Paid",
  "on_account": "Charged to member account",
  "none": "No payment required",
  "refund_pending": "Refund pending",
  "refund_failed": "Refund failed",
  "refunded": "Refunded",
  "terms": "Terms",
  "eligibility": "Eligibility",
  "prerequisite": "Prerequisite",
  "venue": "Venue",
  "schedule": "Schedule",
  "price": "Price per participant",
  "availability": "Places available",
  "noProgrammes": "No programmes match your filters.",
  "noBookings": "You have no Academy bookings.",
  "loading": "Loading Academy…",
  "retry": "Retry",
  "error": "Unable to complete this action. Please retry.",
  "unavailable": "Card payment is unavailable until the club’s provider configuration is complete.",
  "reference": "Booking reference",
  "self": "Self",
  "dependant": "Dependant",
  "accept": "Accept offer",
  "decline": "Decline / leave waiting list",
  "offered": "Place offered",
  "waitingStatus": "Waiting",
  "accepted": "Accepted",
  "declined": "Declined",
  "offering": "Offering",
  "configure": "Member booking configuration",
  "assisted": "Assisted booking",
  "guardianReview": "Guardian authority review",
  "guardian": "Guardian member",
  "payer": "Payer / booking actor",
  "approve": "Approve guardian authority",
  "reason": "Review reason",
  "save": "Publish member policy",
  "description": "Member description",
  "image": "Image URL",
  "categoryLabel": "Category",
  "termsLabel": "Consent and cancellation terms",
  "visible": "Visible to members",
  "selectedDays": "Allow selected days",
  "accountCharge": "Allow member-account charging",
  "cashEnabled": "Allow club cash settlement",
  "cardEnabled": "Allow configured card checkout",
  "refundEnabled": "Refundable before cancellation deadline",
  "cancellationHours": "Cancellation deadline (hours before start)",
  "minAge": "Minimum age (optional)",
  "maxAge": "Maximum age (optional)",
  "taxCode": "Tax code ID",
  "mapping": "Revenue mapping key",
  "bookingOpen": "Booking opens",
  "bookingClose": "Booking closes",
  "history": "Booking history",
  "refresh": "Refresh",
  "selectOffering": "Select an offering",
  "allOrNothing": "Participants book and cancel as a group. Selected days use the published programme price.",
  "startCheckout": "Open secure checkout",
  "resume": "Resume payment",
  "age_unknown": "The club needs a date of birth to check eligibility.",
  "age_ineligible": "This participant is outside the configured age range.",
  "prerequisite_required": "This participant has not met the prerequisite.",
  "guardian_authority_required": "Approved guardian authority is required.",
  "terms_changed": "Terms have changed. Review the current programme before continuing.",
  "payer_authority_required": "You are not authorised to charge this payer.",
  "cancellation_deadline_passed": "The cancellation deadline has passed.",
  "occurrence_history_locked": "This session has started or has attendance evidence.",
  "offering_full": "The programme is full. Join the waiting list.",
  "already_enrolled": "A selected participant already has a place or waiting-list entry.",
  "offering_not_ready": "This programme is no longer bookable.",
  "booking_closed": "The booking window is closed.",
  "member_account_required": "An active member account is required.",
  "currency_unconfigured": "The club must configure its currency.",
  "tax_code_required": "The club must configure an active tax code.",
  "payment_method_unavailable": "This payment method is unavailable.",
  "idempotency_conflict": "This request changed. Start a new booking.",
  "forbidden": "You do not have permission for this action.",
  "credit_limit_exceeded": "This purchase exceeds the member account credit limit.",
  "consent_required": "Accept the terms before confirming.",
  "places_available": "Places are available; book directly.",
  "offer_expired": "This offer has expired.",
  "events": {
    "enrolment_confirmed": "Academy booking confirmed",
    "enrolment_cancelled": "Academy booking cancelled",
    "waiting_joined": "Joined Academy waiting list",
    "place_offered": "Academy place offered",
    "place_offer_expired": "Academy place offer expired",
    "waiting_declined": "Left Academy waiting list",
    "waiting_attention": "Academy waiting list needs review",
    "schedule_changed": "Academy schedule changed",
    "attendance_recorded": "Academy attendance recorded",
    "attendance_corrected": "Academy attendance corrected",
    "payment_attention": "Academy payment needs attention",
    "refund_completed": "Academy refund completed",
    "reminder": "Academy booking reminder"
  },
  "cancelOffering": "Cancel future offering and recover payments",
  "nonMemberDependant": "Non-member dependant name",
  "dateOfBirth": "Date of birth",
  "createDependant": "Create reviewed dependant",
  "upcoming": "Upcoming",
  "past": "Past",
  "attention": "Finance attention",
  "reconcile": "Reconcile provider state",
  "cashRefund": "Confirm cash refund paid",
  "retryRefund": "Retry failed refund",
  "cash_refund_confirmation_required": "Confirm that the cash refund has been paid.",
  "refund_not_retryable": "The provider has not confirmed a terminal refund failure.",
  "accountCredited": "Credit applied to member account",
  "staff_scope_required": "Explicit employee enrolment permission is required.",
  "nonMemberParticipant": "Non-member dependant",
  "personSearch": "Find member or employee",
  "employee": "Employee",
  "member": "Member",
  "employeePayerReview": "Employee payer authority",
  "employeePayerGuidance": "Paid employee places require a reviewed authorisation from the selected member payer. Employment never grants account access.",
  "approvePayer": "Approve explicit payer authority",
  "bookingActorMember": "Booking actor / member contact",
  "payerMember": "Authorised payer",
  "assistingStaff": "Assisting Staff: the verified signed-in club operator.",
  "clubStaffActor": "Club Staff actor (employee groups)",
  "noPayerFreeStaff": "No member payer (free employee group)",
  "selectedOccurrences": "Selected occurrences",
  "clubLocalWindows": "Booking windows in club time",
  "club_timezone_required": "The club must configure a valid IANA timezone.",
  "invalid_local_time": "This club-local time is invalid or falls in a daylight-saving gap. Choose another time.",
  "ambiguous_local_time": "This club-local time occurs twice when clocks change. Choose an unambiguous time.",
  "invalid_booking_window": "Booking close must be after booking open.",
  "waitingManagement": "Waiting lists and offers",
  "sequence": "FIFO sequence",
  "priority": "Audited priority",
  "offerDeadline": "Offer deadline",
  "inspectWaiting": "Inspect waiting group",
  "waitingDetail": "Waiting group details",
  "prepareOffer": "Review place offer",
  "acceptOnBehalf": "Accept offer on behalf",
  "declineOnBehalf": "Decline / leave on behalf",
  "overridePriority": "Save audited priority override"
};
